"use strict";

exports.__esModule = true;
exports.DataTableElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _history = require("history");
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _Core = require("../../Core");
var _DataTable = require("../../Core/DataTable/DataTable");
var _formatColumns = require("../../Core/DataTable/formatColumns");
var _Device = require("../../Device");
var _PlantStateActivitiesContext = require("../../PlantStateActivities/PlantStateActivitiesContext");
var _TicketTypeListContext = require("../../TicketTypes/TicketTypeListContext");
var _Time = require("../../Time");
var _User = require("../../User");
var _DataSources = require("./DataSources");
var _DataTableDataProvider = require("./DataTableDataProvider");
var _ticketing = require("./Formatters/ticketing");
var _helpers = require("./helpers");
var _PlantStateActivities = require("../../PlantStateActivities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* TODO: Set the correct flow type for children, Array<ILayoutElement> doesn't work */

function isClientSideFiltering(configuration) {
  return configuration !== undefined && configuration !== null && configuration.overFetchAll;
}
var DataTableElement = exports.DataTableElement = (0, _reactRouterCompat.withRouter)(function (props) {
  var pageSizeList = [25, 100, 500, 1000];
  var width = props.width,
    height = props.height,
    dataRange = props.dataRange,
    configuration = props.configuration,
    dataItemNames = props.dataItemNames,
    pageSizes = props.pageSizes,
    fetchDataOnlyOnSelection = props.fetchDataOnlyOnSelection,
    children = props.children,
    _props$ticketsWithCom = props.ticketsWithComments,
    ticketsWithComments = _props$ticketsWithCom === void 0 ? true : _props$ticketsWithCom;
  var translator = (0, _react.useContext)(_Core.TranslatorContext);
  var time = (0, _react.useContext)(_Time.TimeContext);
  var users = (0, _react.useContext)(_User.UserListContext);
  var ticketTypes = (0, _react.useContext)(_TicketTypeListContext.TicketTypeListContext);
  var selection = (0, _react.useContext)(_Core.SelectionContext);
  var devices = (0, _react.useContext)(_Device.AllDeviceListContext);
  var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)((0, _react.useContext)(_PlantStateActivitiesContext.PlantStateActivitiesContext));
  var dataSource = props.dataSource;
  var defaultPageSize = (0, _helpers.nearestIndexInPageSizeList)(pageSizes || pageSizeList, (0, _helpers.getDefaultPageSize)(configuration, height) < 0 ? 0 : (0, _helpers.getDefaultPageSize)(configuration, height));
  // Columns are configured on child elements but rendered by the table so gather up the configs
  var columnsConfig = children.map(function (child) {
    return child.props;
  });
  var defaultSorted = (0, _helpers.getDefaultSortOrder)(columnsConfig);
  var defaultFilters = (0, _helpers.getDefaultFilters)(columnsConfig, {
    devices: devices,
    plantStateActivities: plantStateActivities
  });
  var defaultSortedMap = defaultSorted.map(function (_ref) {
    var id = _ref.id,
      desc = _ref.desc;
    return {
      id: id,
      desc: desc
    };
  });
  var _useState = (0, _react.useState)(defaultSortedMap || []),
    sortedState = _useState[0],
    setSortedState = _useState[1];
  var _useState2 = (0, _react.useState)(""),
    searchText = _useState2[0],
    setSearchText = _useState2[1];
  var _useState3 = (0, _react.useState)(function () {
      if (configuration != null && configuration.overFetchAll) {
        return {};
      }
      return {
        number: 0,
        size: defaultPageSize < 0 ? 0 : defaultPageSize,
        sort: configuration != null && configuration.enableFetchOnSort ? (defaultSortedMap || []).map(function (value) {
          return {
            property: value.id,
            direction: value.desc ? "desc" : "asc"
          };
        }) : configuration == null ? void 0 : configuration.sort
      };
    }),
    pagination = _useState3[0],
    setPagination = _useState3[1];
  var _useState4 = (0, _react.useState)([]),
    data = _useState4[0],
    setData = _useState4[1];
  (0, _react.useEffect)(function () {
    if (!(configuration != null && configuration.enableFetchOnSort) && !(configuration != null && configuration.enableFetchOnSearch)) {
      return;
    }
    setPagination(function (current) {
      var next = Object.assign({}, current, configuration != null && configuration.enableFetchOnSort ? {
        sort: sortedState.map(function (value) {
          return {
            property: value.id,
            direction: value.desc ? "desc" : "asc"
          };
        })
      } : {}, configuration != null && configuration.enableFetchOnSearch ? {
        searchTerm: searchText
      } : {});
      return (0, _reactFastCompare["default"])(current, next) ? current : next;
    });
  }, [sortedState, searchText]);
  var translate = translator.translate;
  var dataSourceDefinition = _DataSources.DataSourceDefinitions[dataSource](translate);
  if (dataSource === "Tickets" && ticketsWithComments === true) {
    dataSource = "TicketsWithComments";
  }
  if (selection.isSelectionEmpty(dataRange, fetchDataOnlyOnSelection)) {
    var _data = [];
    var SubComponent = dataSourceDefinition.SubComponent,
      rowFormatters = dataSourceDefinition.rowFormatters;
    var columns = (0, _formatColumns.formatColumns)(columnsConfig, _data, {
      translate: translate,
      time: time,
      devices: devices,
      plantStateActivities: plantStateActivities,
      users: users,
      ticketTypes: ticketTypes
    }, !!SubComponent);
    return /*#__PURE__*/_react["default"].createElement(_DataTable.DataTable, {
      columns: columns,
      data: _data,
      height: height,
      width: width,
      sortedState: sortedState,
      setSortedState: setSortedState,
      searchText: configuration != null && configuration.enableFetchOnSearch ? searchText : undefined,
      handleSearchTextChange: configuration != null && configuration.enableFetchOnSearch ? setSearchText : undefined,
      defaultFiltered: defaultFilters,
      defaultPageSize: defaultPageSize,
      rowFormatters: rowFormatters,
      pageSizeOptions: pageSizes || pageSizeList,
      noDataText: "Make selection to view data",
      editButtonComponent: configuration == null ? void 0 : configuration.editButtonComponent
    });
  }
  var isClientSidePaginationAndFiltering = isClientSideFiltering(configuration);
  function updatePagination(updatedPagination) {
    if (!(0, _reactFastCompare["default"])(pagination, updatedPagination)) {
      setPagination(updatedPagination);
    }
  }
  function handleFetchData(p) {
    updatePagination(Object.assign({}, pagination, {
      size: p.pageSize,
      number: p.page
    }));
  }
  function handleDataChange(updatedData) {
    if (dataSource === "MTC" || dataSource === "metricMTC") {
      setData(((updatedData == null ? void 0 : updatedData.flat()) || []).map(dataSourceDefinition.parseData));
    } else {
      setData(updatedData[dataSource].map(dataSourceDefinition.parseData));
    }
  }
  var aggregateTypes = dataSource === "metricMTC" ? columnsConfig.filter(function (column) {
    return (column == null ? void 0 : column.isAggregated) && (column == null ? void 0 : column.id) != null;
  }).map(function (dataItem) {
    return dataItem.id;
  }) : dataItemNames;
  return /*#__PURE__*/_react["default"].createElement(_DataTableDataProvider.DataTableDataProvider, {
    width: width,
    height: height,
    dataRange: dataRange,
    fetchDataOnlyOnSelection: fetchDataOnlyOnSelection,
    eventSource: dataSource,
    pagination: pagination,
    dataItemNames: dataItemNames,
    aggregateTypes: aggregateTypes,
    onData: handleDataChange
  }, function (_ref2) {
    var fetching = _ref2.fetching,
      reload = _ref2.reload,
      serverPagination = _ref2.serverPagination,
      error = _ref2.error;
    if (error) {
      return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
        error: error
      });
    }
    var SubComponent = dataSourceDefinition.SubComponent,
      rowFormatters = dataSourceDefinition.rowFormatters;
    var columns = (0, _formatColumns.formatColumns)(columnsConfig, data, {
      translate: translate,
      time: time,
      devices: devices,
      plantStateActivities: plantStateActivities,
      users: users,
      ticketTypes: ticketTypes
    }, !!SubComponent);
    if (isClientSidePaginationAndFiltering) {
      return /*#__PURE__*/_react["default"].createElement(_DataTable.DataTable, {
        loading: fetching,
        sortedState: sortedState,
        setSortedState: setSortedState,
        searchText: configuration != null && configuration.enableFetchOnSearch ? searchText : undefined,
        handleSearchTextChange: configuration != null && configuration.enableFetchOnSearch ? setSearchText : undefined,
        defaultFiltered: defaultFilters,
        getDataForCSV: dataSource === "TicketsWithComments" ? function (columns, data) {
          return (0, _ticketing.formatTicketDataToCSV)({
            columns: columns,
            data: data,
            timezone: time.timezone,
            users: users
          });
        } : undefined,
        columns: columns,
        manualSearch: true,
        data: data,
        height: height,
        width: width,
        defaultPageSize: defaultPageSize,
        SubComponent: SubComponent ? function (props) {
          return /*#__PURE__*/_react["default"].createElement(SubComponent, _extends({}, props, {
            refreshData: reload
          }));
        } : undefined,
        rowFormatters: rowFormatters,
        pageSizeOptions: pageSizes || pageSizeList,
        reload: reload,
        editButtonComponent: configuration == null ? void 0 : configuration.editButtonComponent
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_DataTable.DataTable, {
      loading: fetching,
      getDataForCSV: dataSource === "TicketsWithComments" ? function (columns, data) {
        return (0, _ticketing.formatTicketDataToCSV)({
          columns: columns,
          data: data,
          timezone: time.timezone,
          users: users
        });
      } : undefined,
      manual: true,
      sortedState: sortedState,
      setSortedState: setSortedState,
      searchText: configuration != null && configuration.enableFetchOnSearch ? searchText : undefined,
      handleSearchTextChange: configuration != null && configuration.enableFetchOnSearch ? setSearchText : undefined,
      columns: columns,
      data: data,
      height: height,
      width: width,
      defaultPageSize: defaultPageSize,
      defaultFiltered: defaultFilters,
      pageSizeOptions: pageSizeList,
      onFetchData: handleFetchData,
      pages: serverPagination.totalPages || pageSizes,
      SubComponent: SubComponent ? function (props) {
        return /*#__PURE__*/_react["default"].createElement(SubComponent, _extends({}, props, {
          refreshData: reload
        }));
      } : undefined,
      rowFormatters: rowFormatters,
      style: {
        height: height + "px",
        width: width + "px"
      },
      reload: reload,
      editButtonComponent: configuration == null ? void 0 : configuration.editButtonComponent
    });
  });
});